$(document).ready(function(){
  // Initialize Slick slider
  $('.products-slider-main').slick({
      centerMode: true,
      slidesToShow: 1,
      centerPadding: '200px',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            centerPadding: '20px',
            slidesToScroll: 1
          }
        }
      ]
  });

/*   $('.products-slider-main').on('init', function(event, slick){
      // Accordion toggle functionality
      $('.accordion-wrap .accordion-title').click(function(){
          $(this).closest('.accordion-wrap').toggleClass('active');
      });
  });

  $('.products-slider-main').trigger('init');*/
});
 

const productAccordions = document.querySelectorAll('.accordion-wrap');
productAccordions.forEach(accordion => {
  accordion.querySelector('.accordion-title').addEventListener('click', function(){
    if(accordion.classList.contains('active')) {
      accordion.classList.remove('active');
    } else {
      accordion.classList.add('active');
    }
  });
});